import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

export const categoryApi = createApi({
  reducerPath: 'category.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['category'],
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: () => ({ url: '/api/categories' }),
      keepUnusedDataFor: 5,
      providesTags: ['category'],
    }),
    getCategoriesInUse: builder.query({
      query: (inUseOnly) => ({ url: `/api/categories?inUseOnly=${inUseOnly}` }),
      providesTags: ['category'],
    }),
    getCategoryById: builder.query({
      query: (id) => ({ url: `/api/categories/${id}` }),
      providesTags: ['category'],
    }),
    getSubCategoryByParentId: builder.query({
      query: (id) => ({ url: `/api/categories/${id}/sub-categories` }),
      providesTags: ['category'],
    }),
    addCategory: builder.mutation({
      query: (body) => ({
        url: '/api/categories',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['category'],
    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/api/categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['category'],
    }),
    updateCategory: builder.mutation({
      query: (data) => ({
        url: `/api/categories/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['category'],
    }),
    updateSubCategory: builder.mutation({
      query: (data) => ({
        url: `/api/categories/${data.id}/position`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['category'],
    }),
    saveCategoryOrder: builder.mutation({
      query: (data) => ({
        url: `/api/categories/position`,
        method: 'PUT',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoriesInUseQuery,
  useGetCategoryByIdQuery,
  useLazyGetSubCategoryByParentIdQuery,
  useAddCategoryMutation,
  useDeleteCategoryMutation,
  useUpdateCategoryMutation,
  useUpdateSubCategoryMutation,
  useSaveCategoryOrderMutation,
} = categoryApi;
